import React, { useCallback, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

    useEffect(() => {
        const checkUserIsLoggedIn = async () => {
            try {
                const { username, userId, signInDetails } = await getCurrentUser();
                if(username && userId) {
                    setIsAuthenticated(true);
                }
            } catch (error) {
                console.log("User is not logged in", error);
                setIsAuthenticated(false);
            }
        };

        checkUserIsLoggedIn();
    }, []);

    if (isAuthenticated === null) {
        return <div>Loading...</div>;
    }

    return isAuthenticated ? 
        <>{children}</> 
        : 
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        <Navigate to="/" replace />;
};

export default ProtectedRoute;